module.exports = __webpack_public_path__ + "static/9-1c733c8707b6a8cfbb2db500a4326271.png";